import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class Audio extends Component {
  render () {
    const {
      className,
      muted,
      track,
      playback,
      scrubbing,
      currentTime,
      onUpdateDuration,
      onUpdateCurrentTime,
      onEnd
    } = this.props

    if (this.audio) {
      if (playback < 1) {
        this.audio.pause()
        this.audio.currentTime = 0
      } else if (playback === 1) {
        // fix for DOMException: The play() request was interrupted
        // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
        let playPromise = this.audio.play()
        if (playPromise !== undefined) {
          playPromise.then(_ => {
          })
        }
      } else if (playback === 2) {
        this.audio.pause()
      }
      if (scrubbing) {
        this.audio.currentTime = currentTime
      }
    }

    return (
      <div className={className}>
        <audio
          ref={(ref) => { this.audio = ref }}
          src={track && track.url ? track.url : ''}
          muted={muted}
          controls={false}
          autoPlay={playback === 1}
          onTimeUpdate={() => { if (!scrubbing) { onUpdateCurrentTime(this.audio.currentTime) } }}
          onCanPlay={() => onUpdateDuration(this.audio.duration)}
          onEnded={() => onEnd()}
        ></audio>
      </div>
    )
  }
}

Audio.defaultProps = {
  loop: false,
  muted: false,
  className: 'audio',
  preload: 'preload'
}

Audio.propTypes = {
  scrubbing: PropTypes.bool,
  currentTime: PropTypes.number,
  className: PropTypes.string,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  preload: PropTypes.string,
  track: PropTypes.object,
  onEnd: PropTypes.func,
  onUpdateCurrentTime: PropTypes.func,
  onUpdateDuration: PropTypes.func,
  playback: PropTypes.oneOf([-1, 0, 1, 2, 3])
}
